export default abstract class Functions {
  abstract get_uuidv4(): string;

  abstract convert_file_to_base_64(input_file: File): Promise<string | ArrayBuffer | null>;
}
